export const BOARD_COLS = 8;
export const BOARD_ROWS = 8;
export const UI_PANEL_HEIGHT = 88;

// Board artwork (public/assets/sprites/board.png) native dimensions.
export const BOARD_IMG_WIDTH = 1254;
export const BOARD_IMG_HEIGHT = 1254;
export const BOARD_OFFSET_Y = 200;

// Approximate bounding rectangle of the playable 8x8 grid inside the
// perspective board artwork (frame and shadow excluded). The art is drawn
// in perspective so we map the grid via four corner points in image pixels.
// Order: top-left, top-right, bottom-right, bottom-left of the playable area.
// Tune these to align with the inner edge of the wooden frame.
// Press G in-game to toggle a debug overlay that draws the grid and corners.
export const GRID_TL = { x: 250, y: 255 };
export const GRID_TR = { x: 1000, y: 255 };
export const GRID_BR = { x: 1110, y: 870 };
export const GRID_BL = { x: 140, y: 870 };

// Flat top-down (2D) board geometry, in the same image-pixel space as the
// perspective GRID_* corners above (origin at board image top-left).
// The 2D board is drawn with Graphics, so no extra artwork is needed.
export const GRID2D_SIZE = 1120;
export const GRID2D_X = Math.round((BOARD_IMG_WIDTH - GRID2D_SIZE) / 2);
export const GRID2D_Y = GRID2D_X;
export const GRID2D_FRAME = 30;

// 2D board palette, matched to the perspective board artwork.
export const COLOR_2D_LIGHT_SQUARE = 0xf0e7d2;
export const COLOR_2D_DARK_SQUARE = 0x7e94ad;
export const COLOR_2D_FRAME = 0xb48a56;
export const COLOR_2D_FRAME_EDGE = 0x7a5a33;

// Reference piece height (px) used to scale pieces to a cell in 2D view;
// roughly the tallest piece sprite (king ~388px) plus breathing room.
export const PIECE_2D_REF_H = 400;

export const VIEW_MODE_STORAGE_KEY = "chess.viewMode";

// Piece spritesheet (public/assets/spritesheets/pieces.png): 2 rows x 6 cols.
// Row 0 = light (player), Row 1 = dark (enemy).
// Column order: pawn, rook, knight, bishop, queen, king.
export const PIECE_SHEET_FRAME_W = Math.floor(1774 / 6); // 295
export const PIECE_SHEET_FRAME_H = Math.floor(887 / 2);  // 443

// Texture keys
export const TEX_BACKGROUND = "background";
export const TEX_BOARD = "board";
export const TEX_PIECES = "pieces";

// Row indices: row 0 is the TOP of the visible board (enemy side).
// row BOARD_ROWS - 1 is the BOTTOM (player side).
export const PLAYER_BOTTOM_ROW = BOARD_ROWS - 1;
export const ENEMY_TOP_ROW = 0;

// Random initial board generation.
export const INITIAL_PLAYER_PIECES = 8;
export const INITIAL_ENEMY_PIECES = 8;

// Standard per-side chess piece limits.
export const STANDARD_PIECE_CAPS = {
  pawn: 8,
  knight: 2,
  bishop: 2,
  rook: 2,
  queen: 1,
  king: 1,
} as const;

// Number of enemy pieces spawned each time a row wraps to the top.
export const WRAP_SPAWN_MIN = 1;
export const WRAP_SPAWN_MAX = 2;

// Anti-camp pressure: every this many player moves without a wrap (advance),
// the enemy gains one extra piece. The counter resets to 0 on any wrap.
export const STALL_PENALTY_TURNS = 4;

// Hint overlay colors (drawn on top of board artwork).
export const COLOR_SELECT = 0x4cc9f0;
export const COLOR_MOVE_HINT = 0x90ee90;
export const COLOR_CAPTURE_HINT = 0xff6b6b;

// Freshly spawned pieces render translucent while they have summoning
// sickness (cannot capture during the enemy turn right after they spawn).
export const SUMMON_SICK_ALPHA = 0.55;
